import React from 'react';
import { Helmet } from 'react-helmet';
import { createNavigationSchema } from './SiteNavigationElementSchema.utils';
var SiteNavigationElementSchema = function SiteNavigationElementSchema(_ref) {
  var navigationElementId = _ref.navigationElementId,
    siteUrl = _ref.siteUrl,
    pages = _ref.pages;
  var navigationData = createNavigationSchema(pages, siteUrl, navigationElementId);
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(navigationData)));
};
export default SiteNavigationElementSchema;
SiteNavigationElementSchema.defaultProps = {
  navigationElementId: '#nav'
};